// ====================================================
// src/components/block/liveStreamManagement/enchainements/StoreVenitienEnchainement.tsx
//
// Le cadre est divisé en lattes verticales ; chaque latte se découvre de
// gauche à droite EN MÊME TEMPS — c'est cette segmentation qui donne le look
// "store vénitien" plutôt qu'un simple volet (VoletEnchainement) à une seule
// ligne de balayage. Pas de réglage pour l'instant (nombre de lattes fixe).
// ====================================================

import React from 'react';
import { Enchainement, EnchainementControlProps, EnchainementRenderInput } from './Enchainement';

export interface StoreVenitienConfig {}

const LATTES = 12;

class StoreVenitienEnchainementImpl extends Enchainement<StoreVenitienConfig> {
  readonly id = 'storeVenitien';
  readonly label = 'Store vénitien';
  readonly icon = 'Columns3';
  readonly defaultConfig: StoreVenitienConfig = {};

  render(input: EnchainementRenderInput, _config: StoreVenitienConfig): void {
    const { ctx, currentSource, currentRect, nextSource, nextRect, progress, width, height } = input;

    // Flux final fixe en fond, plein cadre.
    ctx.drawImage(currentSource, currentRect.x, currentRect.y, currentRect.w, currentRect.h);

    if (progress <= 0) return;

    const latteW = width / LATTES;
    ctx.save();
    ctx.beginPath();
    for (let i = 0; i < LATTES; i++) {
      ctx.rect(i * latteW, 0, latteW * progress, height);
    }
    ctx.clip();
    ctx.drawImage(nextSource, nextRect.x, nextRect.y, nextRect.w, nextRect.h);
    ctx.restore();
  }

  renderControls(_props: EnchainementControlProps<StoreVenitienConfig>) {
    return null;
  }
}

export const storeVenitienEnchainement = new StoreVenitienEnchainementImpl();
